export const tr = {
    'new-banner': 'Yeni reklam'
};
